/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_News_Readmore1Inputs */

const ja_playdata_home_news_readmore1 = /** @type {(inputs: Playdata_Home_News_Readmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more`)
};

const en_playdata_home_news_readmore1 = /** @type {(inputs: Playdata_Home_News_Readmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read more`)
};

/**
* | output |
* | --- |
* | "Read more" |
*
* @param {Playdata_Home_News_Readmore1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_home_news_readmore1 = /** @type {((inputs?: Playdata_Home_News_Readmore1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_News_Readmore1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_news_readmore1(inputs)
	return en_playdata_home_news_readmore1(inputs)
});
export { playdata_home_news_readmore1 as "playdata_home_news_readMore" }